export enum BannerType {
  Promotion = 'Promotion',
  LuckyWheel = 'LuckyWheel',
  Challenges = 'Challenges',
  Shop = 'Shop',
  Tournaments = 'Tournaments',
  Bottom = 'Bottom'
}
